import { reviewFact, reviewText, statusFromRuntime } from '../../runtime/review-contribution-helpers'
import {
    isActionRequiredDocumentResearchStatus,
    isActiveDocumentResearchStatus,
} from './document-research'

const ANALYSIS_STATUSES = ['created', 'analysis_pending', 'analysis_completed']
const ATTENTION_STATUSES = ['review_pending', 'failed', 'rejected']

const createDocumentsAndWebpagesReviewContribution = ({ context, step }) => {
    const state = context.documentsAndWebpages || {}
    const documents = Array.isArray(state.documents) ? state.documents : []
    const links = Array.isArray(state.links) ? state.links : []
    const statuses = documents
        .map(document => document.processing && document.processing.status)
        .filter(Boolean)
    const researchProcesses = Array.isArray(state.researchProcesses)
        ? state.researchProcesses
        : []
    const researchStatuses = researchProcesses.map(process => process.status).filter(Boolean)
    const baseStatus = statusFromRuntime(step)
    const hasProcessingIssue = statuses.some(value => (
        ANALYSIS_STATUSES.includes(value) || ATTENTION_STATUSES.includes(value)
    )) || researchStatuses.some(value => (
        isActiveDocumentResearchStatus(value)
        || isActionRequiredDocumentResearchStatus(value)
        || ['discovery_failed', 'rejected', 'failed'].includes(value)
    ))
    const isUnconfirmed = baseStatus === 'attention' && !hasProcessingIssue
    const status = baseStatus === 'blocked' || baseStatus === 'pending'
        ? baseStatus
        : statuses.some(value => ANALYSIS_STATUSES.includes(value))
            || researchStatuses.some(value => isActiveDocumentResearchStatus(value))
            ? 'pending'
            : statuses.some(value => ATTENTION_STATUSES.includes(value))
                || researchStatuses.some(value => (
                    isActionRequiredDocumentResearchStatus(value)
                    || ['discovery_failed', 'rejected', 'failed'].includes(value)
                ))
                ? 'attention'
                : baseStatus
    const sourceCount = documents.length + links.length

    return {
        status,
        statusLabel: isUnconfirmed
            ? reviewText(
                'Page(ReceivedRequest):Component(WorkflowReview):not-confirmed',
                'Not confirmed',
            )
            : null,
        summary: reviewText(
            'Page(ReceivedRequest):Component(WorkflowReview):sources-added',
            `${sourceCount} source(s) added`,
            { count: sourceCount },
        ),
        facts: [
            reviewFact(
                'documents',
                reviewText('Component(Label):documents', 'Documents'),
                documents.length,
            ),
            reviewFact(
                'webpages',
                reviewText('Component(Label):webpages', 'Webpages'),
                links.length,
            ),
        ],
        checks: statuses
            .filter(value => ANALYSIS_STATUSES.includes(value) || ATTENTION_STATUSES.includes(value))
            .map((value, index) => ({
                id: `document-${index}-${value}`,
                status: ANALYSIS_STATUSES.includes(value) ? 'pending' : 'failed',
                severity: 'advisory',
                message: reviewText(
                    'Page(ReceivedRequest):Component(WorkflowReview):document-status',
                    `Document status: ${value}`,
                    { status: value },
                ),
            }))
            .concat(researchStatuses
                .filter(value => (
                    isActiveDocumentResearchStatus(value)
                    || isActionRequiredDocumentResearchStatus(value)
                    || ['discovery_failed', 'rejected', 'failed'].includes(value)
                ))
                .map((value, index) => ({
                    id: `document-research-${index}-${value}`,
                    status: isActiveDocumentResearchStatus(value) ? 'pending' : 'failed',
                    severity: 'advisory',
                    message: reviewText(
                        'Page(ReceivedRequest):Component(WorkflowReview):document-research-status',
                        `Webpage research status: ${value}`,
                        { status: value },
                    ),
                })))
            .concat(isUnconfirmed ? [{
                id: 'documents-step-not-confirmed',
                status: 'failed',
                severity: 'advisory',
                message: reviewText(
                    'Page(ReceivedRequest):Component(WorkflowReview):confirm-documents-step',
                    'This step has not been confirmed. Open it and select “Confirm and continue”.',
                ),
            }] : []),
    }
}

export { createDocumentsAndWebpagesReviewContribution }
export default createDocumentsAndWebpagesReviewContribution
